export default "__VITE_ASSET__DPdv_lOb__"